import React, { FC, ReactElement, ReactNode } from 'react'
import { get, isNil } from 'lodash'
import { SvgIcon } from 'components/icon/SvgIcon'
import { ToastrType } from 'types/toastr'

const iconsToTypeMapping = {
  info: 'info',
  success: 'success',
  error: 'error',
  warning: 'warning',
}

interface Props {
  type?: ToastrType
  message?: string | ReactNode
  hasIcon?: boolean
  customIconName?: string
  buttons?: ReactElement | ReactElement[]
  subItem?: string | ReactElement
}

export const ToastrContent: FC<Props> = ({
  type = 'info',
  message = '',
  customIconName,
  hasIcon = true,
  buttons,
  subItem,
}) => (
  <div className="toastr-content">
    <div className="toastr-content-header">
      {hasIcon && (
        <div className="toastr-content-header-icon">
          <SvgIcon name={customIconName || get(iconsToTypeMapping, type, 'info')} />
        </div>
      )}
      <div className="toastr-content-header-text">{message}</div>
      {isNil(subItem) && !isNil(buttons) && <div className="toastr-content-header-buttons">{buttons}</div>}
    </div>
    {!isNil(subItem) && (
      <div className="toastr-content-footer">
        {hasIcon && <div className="toastr-content-footer-icon" />}
        <div className="toastr-content-footer-text">{subItem}</div>
        {!isNil(buttons) && <div className="toastr-content-footer-buttons">{buttons}</div>}
      </div>
    )}
  </div>
)
